import { render, staticRenderFns } from "./FirmaTanimliAlanlarStockCheckbox.vue?vue&type=template&id=10763b14&"
import script from "./FirmaTanimliAlanlarStockCheckbox.vue?vue&type=script&lang=js&"
export * from "./FirmaTanimliAlanlarStockCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports